import React from "react";
import * as IconsPI from "react-icons/pi";
import * as IconsAI from "react-icons/ai";
import * as IconsBI from "react-icons/bi";
import * as IconsFA from "react-icons/fa";
import * as IconsMD from "react-icons/md";
import * as IconsLU from "react-icons/lu";
import * as IconsFA6 from "react-icons/fa6";
import * as IconsLIA from "react-icons/lia";

function IconComponent({ icon, styled }) {
    const IconPI = IconsPI[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconAI = IconsAI[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconBI = IconsBI[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconFA = IconsFA[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconMD = IconsMD[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconLU = IconsLU[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconFA6 = IconsFA6[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    const IconLIA = IconsLIA[icon]; // Use o nome do ícone como uma chave para acessar o ícone correspondente
    
    const Icon = IconPI || IconAI || IconBI || IconFA || IconMD || IconLU || IconFA6 || IconLIA; 

    if (Icon) {
        return <Icon style={styled}/>;
    }
    return null;
}

export default IconComponent;